import * as Sentry from '@sentry/react';
import { Outlet, createRootRoute, useRouter } from '@tanstack/react-router';
import { getAuth, onAuthStateChanged, signInAnonymously } from 'firebase/auth';
import { useEffect } from 'react';

const RouteComponent = () => {
  const router = useRouter();
  const { user } = Route.useRouteContext();

  useEffect(() => {
    if (user) {
      Sentry.setUser({
        id: user.uid,
        email: user.email ?? undefined,
      });
    }
  }, [user]);

  useEffect(() => {
    return onAuthStateChanged(getAuth(), (user) => {
      if (user == null) {
        router.invalidate();
      }
    });
  }, [router]);

  return <Outlet />;
};

export const Route = createRootRoute({
  beforeLoad: async () => {
    const auth = getAuth();

    await auth.authStateReady();

    if (auth.currentUser) {
      return {
        user: auth.currentUser,
      };
    }

    const { user } = await signInAnonymously(auth);

    return {
      user,
    };
  },
  component: RouteComponent,
});
